import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SalesTabMobile = ({ selectedHall }) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;


    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const handleHallSelection = (hallName) => {
        setIsAccordionOpen(false);
        // Navigate to the corresponding mobile sale page
        switch (hallName) {
            case '하늘관 특별실':
                navigate('/sky-special-room');
                break;
            case '하늘관 VIP':
                navigate('/sky-hall-vip-sales');
                break;
            case '햇빛관':
                navigate('/sunlight-hall-sales');
                break;
            case '야외 봉안당':
                navigate('/outdoor-hall-sales');
                break;
            case '하늘관 봉황실':
                navigate('/sky-hall-phoenix-room');
                break;
            case '별빛관':
                navigate('/star-hall-sales');
                break;
            case 'S관':
                navigate('/s-hall-sales');
                break;
            default:
                break;
        }
    };

    return (
        <div>
            {/* First Accordion - Hall Selection */}
            <div className="sky-hall-special-room-mobile-accordion">
                <div
                    className="sky-hall-special-room-mobile-accordion-header"
                    onClick={toggleAccordion}
                    style={{
                        backgroundImage: 'url(/images mobile directions/36_765.svg)',
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <h3>{selectedHall}</h3>
                    <img
                        src="/images mobile directions/7202ea909cb877a6a9c4abd27098600d577ca10d.png"
                        alt="Toggle"
                        className={`sky-hall-special-room-mobile-accordion-toggle ${isAccordionOpen ? 'open' : ''}`}
                    />
                </div>

                {/* First Accordion Dropdown Content */}
                {isAccordionOpen && (
                    <div className="sky-hall-special-room-mobile-accordion-content">
                        <div className="sky-hall-special-room-mobile-hall-grid">
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/sky-special-room' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('하늘관 특별실')}
                            >
                                하늘관 특별실
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/sky-hall-phoenix-room' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('하늘관 봉황실')}
                            >
                                하늘관 봉황실
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/sky-hall-vip-sales' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('하늘관 VIP')}
                            >
                                하늘관 VIP
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/star-hall-sales' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('별빛관')}
                            >
                                별빛관
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/sunlight-hall-sales' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('햇빛관')}
                            >
                                햇빛관
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/s-hall-sales' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('S관')}
                            >
                                S관
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/outdoor-hall-sales' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('야외 봉안당')}
                            >
                                야외 봉안당
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SalesTabMobile;

